import { ROUTES } from '@/lib/routes';

export const data = [
  {
    title: 'Admin Panel',
    authPath: `${ROUTES.SIGN_IN}?section=admin_panel`,
    path: ROUTES.ADMIN_USERS,
    image: '/icons/admin_panel.svg',
    active: true,
  },
  {
    title: 'Previewer',
    authPath: `${ROUTES.SIGN_IN}?section=content`,
    path: ROUTES.CONTENT_EXPLORE,
    image: '/icons/content_management.svg',
    active: true,
  },
];
